import { Sparkles, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';
import { Champ } from './constantes';

export const SyntheseBloc = ({ b, setB, onIA, occupe }) => (
  <section className="rounded-2xl border-2 border-[#8DC63F]/50 bg-white p-5 sm:p-7 shadow-sm" data-testid="cp-synthese">
    <h3 className="flex items-center gap-2 text-base md:text-lg font-semibold text-[#0F172A]"><Sparkles className="h-5 w-5 text-[#6FA22E]" /> Résumé de la séance</h3>
    <p className="mt-1 max-w-3xl text-sm text-slate-500">
      Écrivez vos notes librement : l'IA les remet au propre pour le procès-verbal, sans rien inventer. Relisez et corrigez la synthèse avant de valider.
    </p>
    <div className="mt-5 grid gap-5 lg:grid-cols-2">
      <Champ label="Vos notes (champ libre)">
        <Textarea rows={10} value={b.resume_brut} onChange={(e) => setB((x) => ({ ...x, resume_brut: e.target.value }))} data-testid="cp-resume-brut"
          placeholder="Ex : bilan présenté par le responsable pédagogique, les tuteurs souhaitent plus de liens avec le CFA, décision : bilan à mi-parcours…" />
      </Champ>
      <Champ label="Synthèse pour le procès-verbal">
        <Textarea rows={10} value={b.synthese} onChange={(e) => setB((x) => ({ ...x, synthese: e.target.value }))} data-testid="cp-synthese-texte"
          placeholder="Cliquez sur « Mettre au propre avec l'IA » ou rédigez directement." />
      </Champ>
    </div>
    <Button onClick={onIA} disabled={!!occupe || b.resume_brut.trim().length < 20} className="mt-4 rounded-full bg-[#0F172A] px-5" data-testid="cp-synthese-ia">
      {occupe === 'ia' ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Sparkles className="mr-2 h-4 w-4" />} Mettre au propre avec l'IA
    </Button>
  </section>
);
